/**
 * Speed conversion utilities
 */

export const MS_TO_KMH = 3.6;
export const KMH_TO_MS = 1 / 3.6;
export const KMH_TO_MPH = 0.621371;
export const MPH_TO_KMH = 1.60934;

/**
 * Convert meters per second to km/h
 */
export function msToKmh(ms: number): number {
  if (isNaN(ms) || ms < 0) return 0;
  return ms * MS_TO_KMH;
}

/**
 * Convert km/h to mph
 */
export function kmhToMph(kmh: number): number {
  if (isNaN(kmh) || kmh < 0) return 0;
  return kmh * KMH_TO_MPH;
}

/**
 * Format speed for display
 */
export function formatSpeed(speed: number): string {
  return Math.round(Math.max(0, speed)).toString();
}

/**
 * Format RPM for display with comma (e.g. 4,280)
 */
export function formatRpm(rpm: number): string {
  return Math.round(Math.max(0, rpm)).toLocaleString('en-US');
}
